import { element } from "ember-element-helper"

// Create a helper named -element that is the same as ember-element-helper's element,
// to prevent an import error in ember-animated.
// https://github.com/ember-animation/ember-animated/pull/453#issuecomment-4320283402

export default element
